import { selectCompaniesById } from '../../companies/selectors/base'

export function selectBase(state) {
  return state.crm.contacts
}

export function selectContactIdsByIdentifyingValue(state) {
  return selectBase(state).byIdentifyingValue
}

export function selectContactsById(state) {
  return selectBase(state).byId
}

export function selectContact(state, id) {
  return selectContactsById(state)[id]
}

export function selectLatestLoadedRequestKey(state) {
  return selectBase(state).latestLoadedRequestKey
}

export function selectLatestLoadedSearchTerm(state) {
  return selectBase(state).latestLoadedSearchTerm
}

export function selectLatestRequestKey(state) {
  return selectBase(state).latestRequestKey
}

export function selectRequestsByKey(state) {
  return selectBase(state).byRequestKey
}

export function selectPageCursor(state) {
  return selectBase(state).cursor
}

export function selectTotalContactsCount(state) {
  return selectBase(state).totalCount
}

export function selectSubjectForSubjectId(state, { subjectId }) {
  return (
    selectContactsById(state)[subjectId] ||
    selectCompaniesById(state)[subjectId]
  )
}

export function selectContactIdsByCustomerId(state) {
  return selectBase(state).contactIdsByCustomerId
}
